import InvoiceIcon from '@material-ui/icons/LibraryBooks';
import UrlFilteringList from './UrlFilteringList';

const urlFiltering =  {
    list: UrlFilteringList,
    icon: InvoiceIcon
};

export default urlFiltering;
